import ab from "./ab.json"
import af from "./af.json"
import am from "./am.json"
import an from "./an.json"
import ar from "./ar.json"
import ast from "./ast.json"
import az from "./az.json"
import be from "./be.json"
import bg from "./bg.json"
import bn from "./bn.json"
import ca from "./ca.json"
import ckb from "./ckb.json"
import cs from "./cs.json"
import cy from "./cy.json"
import da from "./da.json"
import de from "./de.json"
import el from "./el.json"
import eo from "./eo.json"
import es from "./es.json"
import es_419 from "./es-419.json"
import et from "./et.json"
import eu from "./eu.json"
import fa from "./fa.json"
import fi from "./fi.json"
import fil from "./fil.json"
import fr from "./fr.json"
import fy from "./fy.json"
import ga from "./ga.json"
import gd from "./gd.json"
import gl from "./gl.json"
import ha from "./ha.json"
import he from "./he.json"
import hr from "./hr.json"
import ht from "./ht.json"
import hu from "./hu.json"
import hy from "./hy.json"
import id from "./id.json"
import is from "./is.json"
import it from "./it.json"
import ja from "./ja.json"
import ja_Hira from "./ja-Hira.json"
import ka from "./ka.json"
import kk from "./kk.json"
import km from "./km.json"
import ko from "./ko.json"
import ku from "./ku.json"
import lt from "./lt.json"
import lv from "./lv.json"
import mi from "./mi.json"
import mn from "./mn.json"
import nb from "./nb.json"
import nl from "./nl.json"
import nn from "./nn.json"
import nso from "./nso.json"
import oc from "./oc.json"
import or from "./or.json"
import pl from "./pl.json"
import pt from "./pt.json"
import pt_br from "./pt-br.json"
import qu from "./qu.json"
import rap from "./rap.json"
import ro from "./ro.json"
import ru from "./ru.json"
import sk from "./sk.json"
import sl from "./sl.json"
import sr from "./sr.json"
import sv from "./sv.json"
import sw from "./sw.json"
import th from "./th.json"
import tn from "./tn.json"
import tr from "./tr.json"
import uk from "./uk.json"
import uz from "./uz.json"
import vi from "./vi.json"
import xh from "./xh.json"
import zh_cn from "./zh-cn.json"
import zh_tw from "./zh-tw.json"
import zu from "./zu.json"

export default {
  ab,
  af,
  am,
  an,
  ar,
  ast,
  az,
  be,
  bg,
  bn,
  ca,
  ckb,
  cs,
  cy,
  da,
  de,
  el,
  eo,
  es,
  es_419,
  et,
  eu,
  fa,
  fi,
  fil,
  fr,
  fy,
  ga,
  gd,
  gl,
  ha,
  he,
  hr,
  ht,
  hu,
  hy,
  id,
  is,
  it,
  ja,
  ja_Hira,
  ka,
  kk,
  km,
  ko,
  ku,
  lt,
  lv,
  mi,
  mn,
  nb,
  nl,
  nn,
  nso,
  oc,
  or,
  pl,
  pt,
  pt_br,
  qu,
  rap,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  sw,
  th,
  tn,
  tr,
  uk,
  uz,
  vi,
  xh,
  zh_cn,
  zh_tw,
  zu,
}
